<template>
  <div>
    <div v-for="(feedback, name, index) in llmChatFeedbackItem.assessment_results" class="llm-chat-item" :key=index>
      <h4 class="feedback-item-title">{{ name }}</h4>
      <p class="feedback-result">{{ feedback.result }}</p>
      <p class="item-content">{{ feedback.feedback }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "llmChatFinalFeedback",
  props: {
    llmChatFeedbackItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

.llm-chat-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 0 28px 0;
}

.feedback-item-title {
  font-size: 20px;
  font-family: "robotoblack", "robotomedium", sans-serif;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: #222;
}

.feedback-result {
  font-family: "robotobold", "robotomedium", sans-serif;
  font-weight: 600;
  font-size: 15px;
  margin: 0 0 8px 0;
  color: #3dbc9e;
}

.item-content {
  font-family: "robotoregular", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  margin: 0;
  color: #444;
}
</style>

